import React from 'react'
import '../Login/Login.css'

import Layout from '../Layout'
import ForgotPasswordFunction from '../../../utils/CommonFunctionality/ForgotPasswordFunction'
import SEO from '../../../utils/CommonFunctionality/SEO'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const ForgotPassword = () => {
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'

    return (
        <>
            {isPrimeBids ? (
                <SEOTAG page="Forgot Password" />
            ) : (
                <SEO title={`${global?.storeDetails?.name} | Forgot Password`} />
            )}
            <Layout>
                <div className="clearfix row vcaLogin">
                    <div className="col-12">
                        <div className="loginFormBox">
                            <ForgotPasswordFunction />
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default ForgotPassword
